import { HttpInterceptorFn } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

const TRACE_TARGETS = [
  /^\//, // relative URLs (same-origin API calls)
  /^https?:\/\/localhost/,
  /^https:\/\/app\.ripabet-staging\.com/,
  /^https:\/\/app\.ripabet\.com/,
  /^https:\/\/app\.gains\.com/,
];

/**
 * HTTP interceptor that adds Sentry trace headers to outgoing API requests
 * for distributed tracing. Propagates `sentry-trace` and `baggage` headers
 * so that backend services can correlate requests with frontend traces.
 *
 * Only targets API origins — CDN and other third-party requests are excluded
 * to avoid CORS preflight failures.
 */
export const sentryTraceInterceptor: HttpInterceptorFn = (req, next) => {
  if (!TRACE_TARGETS.some(pattern => pattern.test(req.url))) {
    return next(req);
  }

  const span = Sentry.getActiveSpan();
  if (!span) {
    return next(req);
  }

  const rootSpan = Sentry.getRootSpan(span);
  const sentryTraceHeader = Sentry.spanToTraceHeader(rootSpan);
  const sentryBaggageHeader = Sentry.spanToBaggageHeader(rootSpan);

  req = req.clone({
    setHeaders: {
      'sentry-trace': sentryTraceHeader,
      ...(sentryBaggageHeader ? { baggage: sentryBaggageHeader } : {}),
    },
  });

  return next(req);
};
